import { render, staticRenderFns } from "./RoomVideo.vue?vue&type=template&id=42d243ba&scoped=true&"
import script from "./RoomVideo.vue?vue&type=script&lang=js&"
export * from "./RoomVideo.vue?vue&type=script&lang=js&"
import style0 from "./RoomVideo.vue?vue&type=style&index=0&id=42d243ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d243ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d243ba')) {
      api.createRecord('42d243ba', component.options)
    } else {
      api.reload('42d243ba', component.options)
    }
    module.hot.accept("./RoomVideo.vue?vue&type=template&id=42d243ba&scoped=true&", function () {
      api.rerender('42d243ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Call/RoomVideo.vue"
export default component.exports